module.exports = __webpack_public_path__ + "img/user.35ca3613.png";